module.exports = __webpack_public_path__ + "static/media/concept-energy-label-a.6babac50.svg";